import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PILLARS = [
  ["Verified Business Identity", "Every company carries a verifiable digital identity — the foundation of commercial trust."],
  ["Company Intelligence", "Structured records: capabilities, decision makers, markets, certifications and activity."],
  ["Business Intent", "What companies offer and what they need — declared, structured and matched."],
  ["AI Matching", "The intelligence engine connects relevant businesses before opportunities pass."],
  ["Lead Intelligence", "Scored, ranked and explained — not all leads are equal."],
  ["Opportunity Intelligence", "Requirements, distribution, funding and partnerships in one marketplace."],
  ["Capital Connections", "Growth capital, lenders and strategic investors inside the network."],
  ["Marketing Automation", "Your profile becomes a marketing engine — content, campaigns, conversion."],
];

export default function About() {
  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-14" data-testid="about-page">
      <p className="gold-kicker mb-3">About 10XGLOBAL</p>
      <h1 className="font-display text-3xl md:text-5xl font-bold text-slate-100 leading-tight max-w-3xl">
        WE ARE BUILDING BUSINESS INFRASTRUCTURE.<br /><span className="text-gold">NOT A WEBSITE.</span>
      </h1>
      <p className="mt-6 text-slate-400 max-w-2xl leading-relaxed">
        10XGLOBAL is not a traditional business directory, membership portal, social network or marketplace. It is a next-generation B2B ecosystem — the intelligence layer connecting what companies ARE with what companies NEED.
      </p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-14" data-testid="about-pillars">
        {PILLARS.map(([t, d]) => (
          <div key={t} className="card-surface p-6">
            <h3 className="font-display font-semibold text-slate-100 text-sm">{t}</h3>
            <p className="text-xs text-slate-500 mt-2.5 leading-relaxed">{d}</p>
          </div>
        ))}
      </div>

      <div className="mt-16 card-surface hairline-gold p-10 text-center" data-testid="about-statement">
        <p className="font-display font-black text-2xl text-slate-100">10XGLOBAL</p>
        <p className="gold-kicker mt-2">The B2B Intelligence & Growth Network</p>
        <p className="text-sm text-slate-400 mt-3">Discover. Connect. Convert. Grow 10X.</p>
        <Link to="/join" className="btn-gold mt-8" data-testid="about-join-btn">JOIN THE NETWORK <ArrowRight size={16} /></Link>
      </div>
    </div>
  );
}
